module.exports = __webpack_public_path__ + "media/images/guides/random-06-698b23445b9d72044ee5ab94d3227560.svg";